import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const SteamCallbackPage: React.FC = () => {
    const { setToken } = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        // Set page title
        document.title = 'Steam Login | Northern Championships Series';
        
        // Get token from query parameters
        const searchParams = new URLSearchParams(window.location.search);
        const receivedToken = searchParams.get("token");
        
        
        if (!receivedToken) {
            console.error("No token received from server");
            alert("No valid token received from server");
            navigate("/");
            return;
        }
        
        // Replace spaces with + if needed (sometimes URL encoding can change + to spaces)
        const token = receivedToken.replace(/ /g, "+");
        
        // Set the token in auth context and navigate to home
        const setTokenAndNavigate = async () => {
            await setToken(token);
            navigate("/");
        };
        
        setTokenAndNavigate();
    }, [navigate, setToken]);

    return (
        <div className="text-center">
            <h1>Steam Login</h1>
            <p>Processing your authentication...</p>
        </div>
    );
};

export default SteamCallbackPage;